<template>
  <div class="page flex-col">
    <van-nav-bar
      title="积分明细"
      left-arrow
      @click-left="$router.back()"
    />
    <van-tabs
      v-model="activeTab"
      title-active-color="#FF6B00"
      swipeable
      animated
    
      class="nav-buttons"
    >
      <van-tab title="我的积分">
 
        <monthly-collapse-list v-if="activeTab === 0" :data="pointsData" />
      </van-tab>
      <van-tab title="我的订单">
        <order-list v-if="activeTab === 1" :orders="orderList" />
      </van-tab>
      

    </van-tabs>

  </div>
</template>
<script>
import MonthlyCollapseList from '@/components/MonthlyCollapseList.vue'; // Import the new component

import OrderList from '../../components/OrderList.vue';
import { NavBar } from 'vant';

export default {
  components: {
    MonthlyCollapseList,
    OrderList,
    [NavBar.name]: NavBar
  },
  data() {
    return {
      loading: false,
      error: null,
      activeTab: 0,
      pointsData: [
        // { id: 1, description: '观看视频', timestamp: '2025-04-22 11:26:41', points: 100 },
        // { id: 2, description: '签到奖励', timestamp: '2025-04-21 08:00:00', points: 10 },
        // { id: 3, description: '邀请好友', timestamp: '2025-01-15 14:30:12', points: 200 },
        // { id: 4, description: '完成任务', timestamp: '2025-01-10 10:05:55', points: 6 },
        // { id: 5, description: '首次登录', timestamp: '2024-09-01 00:00:01', points: 1 },
        // { id: 6, description: '兑换[喜马拉雅FM巅峰会员周卡]', timestamp: '2025-04-22 11:30:21', points: -500 },
        // { id: 7, description: '购买商品A', timestamp: '2025-01-12 09:15:00', points: -38 },
      ],
      orderList: [
        // {
        //   id: 1,
        //   productName: '猫眼电影兑换券一张',
        //   orderNo: '202406010001',
        //   productImg: 'https://img1.360buyimg.com/n6/jfs/t1/101906/9/42686/32533/64afa88cFf3c57a5d/1f8e0a47c8f1a4cf.jpg',
        //   tradeTime: '2024-06-01 12:30:00',
        //   code:'123456'
        // },
        // {
        //   id: 2,
        //   productName: '京东E卡100元',
        //   orderNo: '202406010002',
        //   productImg: 'https://img1.360buyimg.com/n6/jfs/t1/101906/9/42686/32533/64afa88cFf3c57a5d/1f8e0a47c8f1a4cf.jpg',
        //   tradeTime: '2024-06-01 13:00:00',
        //   code:'123456'
        // }
      ]
    };
  },
  created() {
    
    this.fetchPointsData();
    this.fetchOrdersData();
  },
  methods: {
    async fetchPointsData() {
      try {
        this.loading = true;
        const response = await this.$http.post(this.api+'/shop/points');
        let data = response.data;
        

        this.pointsData = data.data.map((item,index) => ({
          id: index,
          description: item.title,
          timestamp: item.created_at,
          points: item.points
        }));
      } catch (error) {
        this.error = '获取积分数据失败';
        this.$toast('请求失败');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchOrdersData() {
      try {
        this.loading = true;
        const response = await this.$http.post(this.api+'/shop/order');
        let data = response.data;
        this.orderList = data.data.map(order => ({
          id: order.id,
          productName: order.title,
          orderNo: order.order_no,
          productImg: order.url,
          tradeTime: order.created_at,
          code: order.code
        }));
      } catch (error) {
        this.error = '获取订单数据失败';
        
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },

};
</script>
<style scoped lang="less">
@import './assets/index.less';

.van-tabs {
  padding: 15px;
  background: #fff;
  margin-bottom: 10px;

  .van-tab {
    padding: 8px 15px;
    font-size: 14px;
    border-radius: 20px;
    transition: opacity 0.2s;

    &--active {
      background: #FF6B00;
      color: #fff;
    }

    &:active {
      opacity: 0.8;
    }
  }
}
.van-nav-bar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  &__title {
    color: #333;
    font-weight: bold;
    font-size: 18px;
  }
  &__arrow {
    color: #666;
  }
}
</style>